import { z } from 'zod'

export const GetPlaceAddressBookSchema = z.object({
  id: z.number(),
  name: z.string(),
})

export const GetPlaceSchema = z.object(
  {
    // address_book: GetPlaceAddressBookSchema.nullish(),
    address: z.string().nullish(),
    address_id: z.number().nullish(),
    city: z.string().nullish(),
    country: z.string({ message: 'Please select a country' }),
    country_code: z.string({ message: 'Country code is required' }),
    formattedAddress: z.string().nullish(),
    lat: z.string().nullish(),
    lng: z.string().nullish(),
    name: z.string().nullish(),
    place_id: z.string().nullish(),
    place_name: z.string().nullish(),
    postcode: z.string().nullish(),
    uk_region: z.string().nullish(),
  },
  { message: 'Please select a location' },
)
